module.exports = __webpack_public_path__ + "assets/img/14_1764.06bedde9.jpg";